export default {
	TaxReturns: function(state) {
		return state.TaxReturns;
	},
	Total: function(state) {
		return state.Total;
	},
	TaxReturnTypeData: function(state) {
		return state.TaxReturnTypeData;
	}
};
